import { render, staticRenderFns } from "./ghsHarmfulRiskClassPop.vue?vue&type=template&id=c6edd59c"
import script from "./ghsHarmfulRiskClassPop.vue?vue&type=script&lang=js"
export * from "./ghsHarmfulRiskClassPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6edd59c')) {
      api.createRecord('c6edd59c', component.options)
    } else {
      api.reload('c6edd59c', component.options)
    }
    module.hot.accept("./ghsHarmfulRiskClassPop.vue?vue&type=template&id=c6edd59c", function () {
      api.rerender('c6edd59c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/ghsHarmfulRiskClassPop.vue"
export default component.exports